import Axios from "axios";
import AxiosConfig from "src/utilities/AxiosConfig";
import type I_BaseAPIResponse from "src/common_interfaces/I_BaseAPIResponse";

const patchSafetyEventEmployee = async (
  id: number,
  employeeId: number
): Promise<boolean> => {
  try {
    const config = AxiosConfig.configValue()
    const response = await Axios.patch<I_BaseAPIResponse<null>>(
      `${process.env.REACT_APP_API_URL}/api/samsara/safety-event/${id}/employee`,
      { EmployeeID: employeeId },
      { headers: { ...config.headers, "content-type": "application/json" } }
    );

    if (response.data.HasError) {
      console.error("API Error:", response.data.ErrorMessage);
      return false;
    }

    return true;
  } catch (error) {
    console.error("Network or parsing error:", error);
    return false;
  }
};

export default patchSafetyEventEmployee;
